import { FC, PropsWithChildren } from 'react';

import { ConvertedBalance, convertedBalance } from '../../utils';
import FormatMoney from '../FormatMoney';
import { FormatMoneyProps } from '../FormatMoney/types';

type IMoneyWithRateProps = PropsWithChildren<{}> &
  FormatMoneyProps &
  ConvertedBalance;

const MoneyWithRate: FC<IMoneyWithRateProps> = ({ value, ...rest }) => {
  return (
    <FormatMoney
      value={convertedBalance({
        value,
        ...rest,
      })}
      {...rest}
    />
  );
};

export default MoneyWithRate;
